import { useMutation } from "@apollo/react-hooks";
import { UPDATE_SPENDING } from "../api/spending";
import { popSpending, insertSpending, isWithinQueryWindow } from "../utils/spending";

export default (queryOption, onCompleted) => {
  return useMutation(UPDATE_SPENDING, {
    onCompleted,
    update(cache, { data: { updateSpending } }) {
      const { spendings } = cache.readQuery(queryOption);

      const newSpendings = [...spendings];
      popSpending(newSpendings, updateSpending);

      // 月檢視下日期被改到窗口外時只移除、不回插，避免別的月份的紀錄留在當前清單。
      if (isWithinQueryWindow(updateSpending.date, queryOption.variables)) {
        insertSpending(newSpendings, updateSpending);
      }

      cache.writeQuery({
        ...queryOption,
        data: { spendings: newSpendings },
      });
    },
  });
};
